import { render, staticRenderFns } from "./ContactSidebar.vue?vue&type=template&id=111221db&scoped=true&"
import script from "./ContactSidebar.vue?vue&type=script&lang=js&"
export * from "./ContactSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111221db",
  null
  
)

export default component.exports